<div class="time-container">
  <div *ngIf="!(hideRedundant && !days)" class="time-item">
    <span class="time-field">
      <mb-countdown-time [time]="days" [class.three-digits-days]="(days + '').length === 3"></mb-countdown-time>
    </span>
    <span class="time-label">{{ (days === 1 ? 'DAY' : 'DAYS') | translate }}</span>
  </div>
  <div *ngIf="!(hideRedundant && !hours)" class="time-item">
    <span class="time-field"><mb-countdown-time [time]="hours"></mb-countdown-time></span>
    <span class="time-label">{{ 'SHORT_HOURS' | translate }}</span>
  </div>
  <div *ngIf="!(hideRedundant && !minutes)" class="time-item">
    <span class="time-field"><mb-countdown-time [time]="minutes"></mb-countdown-time></span>
    <span class="time-label">{{ 'SHORT_MINUTES' | translate }}</span>
  </div>
  <div *ngIf="!(hideRedundant && !seconds)" class="time-item">
    <span class="time-field"><mb-countdown-time [time]="seconds"></mb-countdown-time></span>
    <span class="time-label">{{ 'SHORT_SECONDS' | translate }}</span>
  </div>
</div>
